module.exports = __webpack_public_path__ + "img/installments.7e0c825.png";